import { render } from "./ArticleFormComponent.vue?vue&type=template&id=7f004d25"
import script from "./ArticleFormComponent.vue?vue&type=script&lang=js"
export * from "./ArticleFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__